import $ from "jquery";
import jQuery from "jquery";
import {forEach} from './helpers/forEach';
import inputAnimation from './module/inputAnimation'
import {FormValidation} from './FormValidation';
import {Stepper} from './Stepper';
import {Accordion} from './accordion';
import Colcade from './colcade';
import {FormFilterClass} from './module/Formfilter'
import Pikaday from 'pikaday'
import Alert from './alert';
import {recaptcha} from './module/recaptcha';

// export for others scripts to use
window.$ = $;
window.jQuery = jQuery;

// // set CSRF token for every AJAX request using jquery.cookie
// require('jquery.cookie');
// $.ajaxSetup({ headers: { 'X-XSRF-TOKEN': $.cookie('XSRF-TOKEN') } });


const AUTOFILLED = 'is-autofilled';
const onAutoFillStart = (el) => el.classList.add(AUTOFILLED);
const onAutoFillCancel = (el) => el.classList.remove(AUTOFILLED);
const onAnimationStart = ({target, animationName}) => {
    switch (animationName) {
        case 'onAutoFillStart':
            return onAutoFillStart(target);
        case 'onAutoFillCancel':
            return onAutoFillCancel(target)
    }
};

let inputs = document.querySelector('input');

if (inputs) {
    inputs.addEventListener('animationstart', onAnimationStart, false);
}


new inputAnimation();

const Dropzone = require('dropzone/downloads/dropzone.js');
Dropzone.autoDiscover = false;
window.Dropzone = Dropzone;

/*
 * Form validation
 */

const forms = document.getElementsByClassName('form-validation');
if (forms.length > 0) {
    forEach(forms, function (form) {
        const afterElement = document.getElementById(form.dataset.after);
        let $form = $(form);
        new FormValidation($(form), {
            inputGroup: 'input-group',
            loading: '<i class="fa fa-spinner fa-spin"></i>',
            error: '<i class="fa fa-times"></i>',
            button: form.querySelector('[type=submit]'),
            onSubmitFailed: res => {
                let list = ['U bent nog wat velden vergeten: \n'];
                Object.keys(res.errors).forEach(function (key) {
                    list = list.concat(res.errors[key]);
                });
                alert(list.join(' \n'));
            },
            onSubmitSuccess: res => {
                if ($form.data('ga') && window.gtag !== undefined) {
                    gtag('event', $form.data('event'), {
                        'event_category': $form.data('ga'),
                        'event_label': $form.data('url')
                    });
                }

                if (form.dataset.hasOwnProperty('feedbackurl')) {
                    window.location.href = form.dataset.feedbackurl;

                } else {
                    let alert = new Alert({
                        text: res.message,
                        element: afterElement,
                        amount: res.amount ? res.amount : 10000
                    });

                    if (form.classList.contains('after-hide')) {
                        form.style.display = 'none';
                        $('.form-confirmation')
                            .removeClass('d-none')
                            .attr('style', 'display: block !important');
                    }

                }
            },
            beforeSubmit: () => {
                // toggleAlert(alert, 'none');
                $(form).find('.form-error').text('');
            }
        });
    });
}

// Edit profile form validation
const profileForms = document.getElementsByClassName('profile-validation');
if (profileForms.length > 0) {
    forEach(profileForms, function (form) {
        const alert = form.dataset.after;

        new FormValidation($(form), {
            inputGroup: 'input-group',
            loading: '<i class="fa fa-spinner fa-spin"></i>',
            error: '<i class="fa fa-times"></i>',
            button: form.querySelector('[type=submit]'),
            onSubmitFailed: (res) => {
                const message = res.message || 'De opgegeven inloggegevens zijn incorrect.';
                $(form).find('.form-error').text(message);
            },
            onSubmitSuccess: () => {
                $(form).find('.form-error').text('Gegevens gewijzigd');
            },
            beforeSubmit: () => {
                $(form).find('.form-error').text('');
            }
        });
    });
}

const steppers = document.getElementsByClassName('stepper-wrapper');
if (steppers.length > 0) {

    forEach(steppers, function (stepper) {
        let form = $(stepper).find('form');
        new Stepper($(stepper), {
            canGoToNextStep: () => {
                let check = form.valid();
                if (!check) {
                    form.trigger('submit');
                }
                return check;
            }
        });
    });
}


const alerts = document.getElementsByClassName('alert-cross');

if (alerts.length > 0) {
    forEach(alerts, function (alert) {
        alert.addEventListener('click', () => {
            alert.parentNode.style.display = 'none';
        });
    });
}

$(document).ready(function () {
    new recaptcha();

    // NAV Drop down
    $(".nav-menu__item__hover").each(function () {
        let hoverKey = `[data-hover-items="${$(this).data("hover")}"]`
        $(this).hover(
            () => {
                $(hoverKey).show();
            },
            () => {
                $(hoverKey).hide();
            },
        );
        $(hoverKey).hover(
            () => {
                $(hoverKey).show();
            },
            () => {
                $(hoverKey).hide();
            },
        )
    });
// END NAV Drop down
});


let parallax = $(".parallax");

$(window).on("scroll", function () {
    var scrollTop = $(document).scrollTop() / 3;


    if (parallax) {
        scrollTop = 200 < scrollTop ? 200 : scrollTop;
        parallax.css({
            transform: "translate3d(0," + scrollTop + "px, 0)",
            opacity: function () {
                return 1 - scrollTop / 200;
            }
        });
    }
});

const body = document.body; // For Safari
let $packages = document.querySelectorAll('[data-package]');
if ($packages.length) {
    var html = document.documentElement;
    const setValuePackage = ($value) => {
        let form = document.getElementById('package-form');
        let input = $('#package-form select[name=type]');
        input.val($value);
        form.scrollIntoView(true);
        window.scrollBy(0, -90); // Adjust scrolling with a negative value here
    };

    forEach($packages, ($pack) => {
        $pack.onclick = function (e) {
            setValuePackage(e.target.dataset.package)
        };
    });
}

let wrappers = document.getElementsByClassName('accordion_wrappers');

if (wrappers.length) {
    forEach(wrappers, function (wrapper) {
        new Accordion(wrapper);
    });
}

let nav = document.querySelector('nav');
window.onscroll = function () {
    if (window.pageYOffset === 0) {
        nav.classList.remove('nav--scrolled')
    } else {
        nav.classList.add('nav--scrolled')
    }
};

const mobileWrapper = document.getElementsByClassName('mobile-nav')[0];
mobileWrapper.classList.add('mobile-nav--init');
const closeMobileMenu = () => {
    body.classList.remove('is-locked');
    mobileWrapper.classList.remove('mobile-nav--is-active')
};

const openMobileMenu = () => {
    body.classList.add('is-locked');
    mobileWrapper.classList.add('mobile-nav--is-active')

};

document.getElementById('open-mobile-menu').onclick = () => openMobileMenu();
document.getElementById('close-mobile-menu').onclick = () => closeMobileMenu();

// login popup
let loginButton = document.getElementById('toggle-login');
let loginWrapper = document.getElementById('login-popup');

if (loginButton) {
    loginWrapper.classList.add('login--init');
    loginButton.onclick = () => {

        if (loginWrapper.classList.contains('login--isactive')) {
            loginWrapper.classList.remove('login--isactive');
            return false;
        }

        let loginRect = loginButton.getBoundingClientRect();
        loginWrapper.style.top = nav.getBoundingClientRect().height + 'px';
        loginWrapper.style.left = loginRect.x + loginRect.width - loginWrapper.getBoundingClientRect().width + 'px'
        loginWrapper.classList.add('login--isactive');
    };
}

// END login popup

// Blog layout

var grid = document.querySelector('.grid');

if (grid) {
    let colc = new Colcade(grid, {
        columns: '.grid-col',
        items: '.grid-item'
    });

    new FormFilterClass({
        form: document.getElementById('webshopfilter'),
        container: document.getElementById('ajax-results'),
        lazyload: 400,
        loader: document.getElementById('append_loader'),
        processResponse: (container, items, append) => {
            colc.append(document.createRange().createContextualFragment(items));
        }
    });
}

// end blog layout

/*
 * Load news items
 */
$(function () {
    const container = document.getElementById('news-results');

    if (container) {
        new FormFilterClass({
            form: document.getElementById('webshopfilter'),
            container: container,
            lazyload: 400,
            loader: document.getElementById('append_loader'),
        });
    }
})


$('[data-input-name]').each(function () {
    let $form = $(this).closest('form');
    let input = $form.find(`[name=${this.dataset.inputName}]`);
    if (input.length !== 0) {
        input[0].addEventListener('input', (e) => {
            this.innerText = e.target.value;
        });
    }
});


let pikadays = document.getElementsByClassName('pikadate');
if (pikadays.length) {
    for (let $i = 0; $i < pikadays.length; $i++) {
        let pikadate = pikadays[$i];
        let maxDate = new Date(new Date().setFullYear(new Date().getFullYear() - 15));
        let minDate = new Date(new Date().setFullYear(new Date().getFullYear() - 100));
        new Pikaday({
            field: pikadate,
            minDate: minDate,
            maxDate: maxDate,
            defaultDate: maxDate,
            yearRange: 100,
            toString(date, format) {
                // you should do formatting based on the passed format,
                // but we will just return 'D/M/YYYY' for simplicity
                const day = date.getDate();
                const month = date.getMonth() + 1;
                const year = date.getFullYear();
                return `${day}-${month}-${year}`;
            },
        });
    }
}

const requesterName = document.getElementsByName('requester_name');
if (requesterName.length > 0) {
    let text = document.getElementsByClassName('verklaring-header');
    if (text.length > 0) {
        text[0].innerHTML = text[0].innerHTML.replace(/\[company\]/g, requesterName[0].value);
    }
}


let inputCourseDates = document.querySelector('[name="course_dates"]');
let inputPaymentTime = document.querySelector('[name="payment_time"]');
let teacherInput = document.getElementById('-teachers');
if (inputCourseDates && inputPaymentTime) {

    const CheckIfValueIsOnline = () => {

        if (inputCourseDates.value === 'online_with_teacher') {
            teacherInput.style.display = 'block';

            for (let i = 0; i < inputPaymentTime.length; i++) {
                if (inputPaymentTime.value !== 'one_time') {
                    inputPaymentTime[0].selected = true
                }

                let item = inputPaymentTime[i];
                (item.value === "interval") ? item.disabled = true : item.disabled = false;
            }
        } else {
            teacherInput.style.display = 'none';
            for (let i = 0; i < inputPaymentTime.length; i++) {
                inputPaymentTime[i].disabled = false;
            }
        }
    };
    CheckIfValueIsOnline();
    inputCourseDates.addEventListener('change', CheckIfValueIsOnline);
}


